<template>
<div v-if="filteredPaymentCards.length">
  <h1>{{ t('MINHA_CARTEIRA') }}</h1>
  <div >
    <div class="divCardSpan" :key="index" v-for="(card,index) in filteredPaymentCards">
      <span> {{card.cardNumber}}</span>
      <a style="cursor:pointer;" @click="dialog = true; message = 'bloqueio'; cardToRemove = card.id">{{ t('REMOVER') }}</a>
    </div>
  <v-app>
   <v-dialog @input="v => v || updateUser()" :fullscreen="isMobile() && !message" v-model="dialog" max-width="600px" >
      <template v-slot:activator="{ on }">
         <!--<a @click="createCard()"  appEvent="true" appEventCategory="meus-dados" appEventLabel="adicionar cartão de pagamento" class="popupLink">adicionar cartão de pagamento</a>-->
      </template>
      <v-card v-if="link && !message">
       <v-card-title style="display:block;" class="styled-header">
        <span class="headline">{{ t('ADICIONAR_CARTAO_PAGAMENTO') }}</span>
          <span @click="closePopup" class="close">X</span>
        </v-card-title>
        <div class="resp-container">
          <iframe class="resp-iframe" :src="link" allow="encrypted-media" allowfullscreen></iframe>
        </div>
      </v-card>
      <v-card class="withoutHeader" v-if="message">
           <v-card-title>
           </v-card-title>
            <v-card-text v-if="message === 'bloqueio' " >
             <span class="headline">{{ t('DESEJA_REMOVER_CARTAO') }}</span>
            <p>{{ t('DESEJA_REMOVER_CARTAO_INFO') }}</p>
          </v-card-text>
          <v-card-text v-else>
             <span class="headline">{{message}}</span>
          </v-card-text>
           <a v-if="message === 'bloqueio'" @click="removeCard(cardToRemove)"  appEvent="true" appEventCategory="meus-dados" appEventLabel="remover cartão de pagamento" class="btn block">{{ t('REMOVER') }}</a>
           <a v-else @click="closePopup" class="btn block">{{ t('FECHAR') }}</a>

            <v-card-title>
         
           
           </v-card-title>
      </v-card>

    </v-dialog>
  </v-app>
  </div>
</div>
</template>

<script>
import {VDialog,VCard,VCardTitle,VCardText,VApp} from 'vuetify/lib'
import {save,block} from '../services/paymentCard.service'
import {resolvePromise, emitToParent,isMobile} from "../helpers/helpers.js"
import { translate } from '../services/translate.service';
export default {
  name: 'MinhaCarteira',
  data(){
     return{
      dialog:false,
      link:null,
      message:null,
      cardToRemove:null
    }
  },
  props: {
      paymentCards:{
        type:Array
      },
      userId:{
        type:Number
      }
  },
  computed:{
    filteredPaymentCards(){
      return this.paymentCards ? this.paymentCards.filter(c=>c.cardNumber && c.active) : []
    },
    
  },
  methods:{
    t:translate,
    isMobile,
    updateUser(){
      emitToParent("retrieveMyUser",this)
    },
    closePopup:function(){
      this.dialog = false
      this.link = null
      this.message = null
      this.updateUser()
    },
    createCard:function(){
      resolvePromise(save(),({data})=>{ this.message = null; this.link = data.url;this.dialog = true;this.updateUser()},console.log,this)
    },
    removeCard:function(id){
      
      const formData = new FormData();
      formData.append("Active",false)
      resolvePromise(block(id,formData),()=>this.message = translate('CARTAO_REMOVIDO'),err=> this.message = err,this)
      this.updateUser()
     }
  },
  components:{
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VApp
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/minhaCarteira.scss";
</style>
